<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      append-to-body
      title="选择"
      width="1200px">
    <vm-table
        ref="vmTable"
        :filter.sync="filter"
        module="basic"
        url="soas/receiveDetail"
        @select="select"
        @select-all="select">
      <div slot="toolbar">
        <el-button type="primary" @click="add()">新增</el-button>
      </div>
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="采购订单">
            <el-input
                v-model.trim="filter.evaluate"
                type="textarea"
                autosize
                placeholder="请输入采购订单号"
                clearable/>
          </vm-search>
          <vm-search label="送货单号">
            <el-input
                v-model.trim="filter.asnNo"
                type="textarea"
                autosize
                placeholder="请输入送货单号"
                clearable/>
          </vm-search>
          <vm-search label="物料编号">
            <el-input v-model.trim="filter.partNo" placeholder="请输入物料编号" clearable/>
          </vm-search>
          <vm-search label="物料名称">
            <el-input v-model.trim="filter.partNameSpec" placeholder="请输入物料名称" clearable/>
          </vm-search>
          <vm-search label="采购组">
            <el-input v-model.trim="filter.buyUserName" placeholder="请输入采购组" clearable/>
          </vm-search>
          <vm-search label="供应商编号">
            <el-input v-model.trim="filter.supplierNo" placeholder="请输入供应商编号" clearable/>
          </vm-search>
          <vm-search label="对账状态">
            <el-select v-model.trim="filter.soaStatus" placeholder="请选择对账状态">
              <el-option label="未对账" :value="'未对账'"/>
              <el-option label="部分对账" :value="'部分对账'"/>
              <el-option label="已对账" :value="'已对账'"/>
            </el-select>
          </vm-search>
          <vm-search label="直发标识">
            <el-select v-model.trim="filter.straightMark">
              <el-option label="全部" value=""/>
              <el-option label="直发" value="Z001"/>
              <el-option label="非直发" value="1000"/>
            </el-select>
          </vm-search>
        </div>
        <div>
          <vm-search label="到货日期：">
            <div class="block">
              <el-date-picker
                  v-model="filter.arriveDateBegin"
                  style="width:150px"
                  value-format="yyyy-MM-dd"
                  placeholder="请选择"
                  type="date"/>
            </div>
          </vm-search>
          <vm-search label="至">
            <div class="block">
              <el-date-picker
                  v-model="filter.arriveDateEnd"
                  style="width:163px"
                  value-format="yyyy-MM-dd"
                  placeholder="请选择"
                  type="date"/>
            </div>
          </vm-search>
          <vm-search label="创建日期：">
            <div class="block">
              <el-date-picker
                  v-model="filter.createDateBegin"
                  style="width:150px"
                  value-format="yyyy-MM-dd"
                  placeholder="请选择"
                  type="date"/>
            </div>
          </vm-search>
          <vm-search label="至">
            <div class="block">
              <el-date-picker
                  v-model="filter.createDateEnd"
                  style="width:163px"
                  value-format="yyyy-MM-dd"
                  placeholder="请选择"
                  type="date"/>
            </div>
          </vm-search>
        </div>
      </template>
      <el-table-column type="selection" align="center" width="45"/>
      <el-table-column prop="asnNo" align="center" width="140" label="送货单号"/>
      <el-table-column prop="asnRowIndex" align="center" width="60" label="行号"/>
      <el-table-column prop="evaluate" align="center" width="120" label="采购订单号"/>
      <el-table-column prop="poDetailRowNo" align="center" width="80" label="行号"/>
      <el-table-column prop="partNo" width="100" align="center" label="物料编号"/>
      <el-table-column prop="partNameSpec" show-overflow-tooltip label="物料名称"/>
      <el-table-column
          prop="buyUserName"
          width="100"
          align="center"
          show-overflow-tooltip
          label="采购组"/>
      <el-table-column
          prop="supplierNo"
          show-overflow-tooltip
          width="90"
          align="center"
          label="供应商编号"/>
      <el-table-column
          prop="supplierName"
          show-overflow-tooltip
          align="center"
          width="90"
          label="供应商名称"/>
      <el-table-column label="直发标识" width="80" align="center">
        <template slot-scope="scope">
          <span>{{scope.row.straightMark === "1000" ? "非直发" : "直发"}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="createdTime" align="center" width="180" label="送货单创建日期"/>
      <el-table-column prop="arrivedTime" align="center" width="180" label="送货单到货日期"/>
      <el-table-column prop="sumQuantity" align="center" width="90" label="送货单数量"/>
      <el-table-column prop="instockQuantity" align="center" width="105" label="送货单入库数量"/>
      <el-table-column prop="leftQuantity" align="center" width="105" label="剩余可对账数量"/>
      <el-table-column prop="soaStatus" align="center" width="90" label="状态"/>
    </vm-table>
  </el-dialog>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";

  export default {
    name: "",
    components: { VmTable, VmSearch },
    data() {
      return {
        dialogVisible: false,
        filter: {
          filter: {
            evaluate: "",
            asnNo: "",
            partNo: "",
            partNameSpec: "",
            soaStatus: "未对账",
            straightMark: "",
            buyUserName: "",
            supplierNo: "",
            arriveDateEnd: "",
            arriveDateBegin: "",
            createDateBegin: "",
            createDateEnd: "",
          },
        },
      };
    },
    methods: {
      open() {
        this.dialogVisible = true;
        this.$nextTick(() => {
          this.$refs.vmTable.getList(1);
        });
      },
      // // 选择
      // onSelect(row) {
      //   this.$emit("select", row);
      //   this.dialogVisible = false;
      // },
      select(selection) {
        this.selection = selection;
        // this.buyOrderNoList = [];
        // this.$emit("selectAll", this.selection);
        // this.dialogVisible = false;
      },
      add() {
        if(this.selection) {
          this.$emit("select", this.selection);
          this.dialogVisible = false;
        }else {
          this.$message.error("请选择需要添加的行项！");
        }
        
      },
    },
  };
</script>